import NotificationsCustom from './NotificationsCustom';

export default NotificationsCustom;
